'use client';

import { ChakraProvider } from '@chakra-ui/react';
import theme from '../../component-library/theme/theme';

import { ColorModeProvider, type ColorModeProviderProps } from '../../components/ui/color-mode';

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={theme}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
}
